import styled from 'styled-components'

export const StyledDraggable = styled.div`
    display: inline-block;
`
